import loadjs from "loadjs"
import { useEffect } from "react"

import Image from "components/ui/image"

const GiftFinder = () => {
  useEffect(() => {
    const loadQuiz = () => {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        "11f4864a-67f2-4a0f-8878-42d9343fc9f5" // 320909
      )
    }

    if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX) {
      loadQuiz()
    } else {
      loadjs(
        [
          `https://www.lightboxcdn.com/vendor/7c3a4ec6-f10d-4926-b14d-64ee5d0a9611/lightbox_speed.js?mb=${new Date().getTime()}`,
        ],
        { async: true, returnPromise: true }
      )
        .then(() => loadQuiz())
        .catch((err) => console.log(`Error loading quiz: ${err}`))
    }
  }, [])

  return (
    <div
      className="[&>*:nth-child(n+2)]:hidden"
      id="gift-finder-quiz"
      style={{ minHeight: "560px" }}
    >
      <div className="my-48 text-center" style={{ minHeight: "350px" }}>
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </div>
    </div>
  )
}

export default GiftFinder
